const TYPES = {
  LINK: 'link',
  EMAIL: 'email',
  PROJECT: 'project',
};

export type TransferType = typeof TYPES[keyof typeof TYPES];
export const TRANSFER_TYPES = Object.freeze(TYPES);
